module.exports = __webpack_public_path__ + "img/deviceBigScreenBgc.dbbf4ebe.jpg";